/**
 * HAWK UI CONTROLLER vFinal (Button Visibility & Mobile Fix)
 * - updateButtonVisibility fonksiyonu geri getirildi.
 * - Uyarı modalı eski detaylı metinlerine döndürüldü.
 * - Mobilde 'Fiyatı Gör' butonu, işlem sırasında gizleniyor.
 */

class HawkUIController {
    constructor() {
        this.activeOptionIndex = 0;
        this.globals = window; 
        this.pendingAction = null; 
        this.tempFileSelected = false; // <--- Eklendi

        this.injectStyles();       
        this.createWarningModal(); 
        
        this.initCustomizationArea();
        this.initEventListeners();
        // Faz 2: yeni mobil düzen açıkken eski 3 sayfalık sihirbaz devre dışı.
        // Bayrak src/ui/flags.ts içinde, bu modülden ÖNCE kuruluyor.
        if (!window.HAWK_UI_V2) this.initMobileUI();
        this.initDarkMode();
        this.initRemoveButtons();
        this.initUnifiedWidget();      
        
    }

    initRemoveButtons() {
        const removeBtns = document.querySelectorAll('.remove-button');
        removeBtns.forEach(btn => {
            // Önce varsa eski event listener'ı temizlemek için klonlama yapılabilir
            // ama basitçe click event ekliyoruz:
            btn.addEventListener('click', (e) => {
                e.stopPropagation(); // Tıklama yukarı taşmasın
                const val = btn.getAttribute('value');
                this.handleRemoveClick(val);
            });
        });
    }

   // -------------------------------------------------------
    // UNIFIED SUPPORT WIDGET (TAB SWITCH FIX)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // UNIFIED SUPPORT WIDGET (KESİN SEKME GEÇİŞİ)
    // -------------------------------------------------------
    initUnifiedWidget() {
        
        const mainBtn = document.getElementById('hawkSupportBtn');
        const closeBtn = document.getElementById('closeUnifiedBtn');
        const widget = document.getElementById('hawkUnifiedWidget');
        const iframe = document.getElementById('hawkChatFrame');
        const tabs = document.querySelectorAll('.hawk-tab-btn');
        
        const chatUrl = "https://hawk-app-atcnf.ondigitalocean.app/";

        if (!mainBtn || !widget) return;

        // 1. ANA BUTON (AÇ/KAPA)
        // Eski listener'ı temizle
        const newMainBtn = mainBtn.cloneNode(true);
        mainBtn.parentNode.replaceChild(newMainBtn, mainBtn);

        newMainBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const isVisible = widget.classList.contains('active');
            
            if (isVisible) {
                // KAPAT
                widget.classList.remove('active');
                setTimeout(() => { 
                    widget.style.display = 'none'; 
                    if(iframe) iframe.src = ""; // Kapanınca sıfırla (Maliyet tasarrufu)
                }, 300);
            } else {
                // AÇ
                widget.style.display = 'flex';
                void widget.offsetWidth; // Reflow
                widget.classList.add('active');

                // Varsayılan olarak CHAT sekmesini aç ve resetle
                // Her açılışta Chat ile başlamasını istiyorsan:
                const currentTabs = document.querySelectorAll('.hawk-tab-btn'); 
                if(currentTabs[0]) currentTabs[0].click();
                
                // Veya son kalınan yerden devam etsin istiyorsan sadece iframe kontrolü yap:
                /*
                if (iframe && !iframe.src) iframe.src = chatUrl;
                */
            }
        });

        // 2. KAPATMA BUTONU (X)
        if (closeBtn) {
            const newCloseBtn = closeBtn.cloneNode(true);
            closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
            newCloseBtn.addEventListener('click', () => {
                widget.classList.remove('active');
                setTimeout(() => { 
                    widget.style.display = 'none';
                    if(iframe) iframe.src = ""; 
                }, 300);
            });
        }

        // 3. SEKME GEÇİŞLERİ (TAB SWITCHING)
        tabs.forEach(tab => {
            const newTab = tab.cloneNode(true);
            tab.parentNode.replaceChild(newTab, tab);

            newTab.addEventListener('click', () => {
                const target = newTab.dataset.target; // 'chat' veya 'order'
                console.log(`📑 Sekme Geçişi: ${target}`);

                // A) BUTONLARI GÜNCELLE
                document.querySelectorAll('.hawk-tab-btn').forEach(t => t.classList.remove('active'));
                newTab.classList.add('active');
                
                // B) İÇERİKLERİ GİZLE/GÖSTER (KESİN YÖNTEM)
                // Önce hepsini gizle
                document.querySelectorAll('.hawk-tab-content').forEach(c => {
                    c.classList.remove('active');
                    c.style.display = 'none'; // CSS'i JS ile zorla
                });

                // Hedef içeriği bul ve aç
                const targetContent = document.getElementById(`tab-content-${target}`);
                if (targetContent) {
                    targetContent.style.display = 'flex'; // Flex olarak aç
                    setTimeout(() => targetContent.classList.add('active'), 10);
                }

                // C) IFRAME YÖNETİMİ
                if (target === 'chat') {
                    // Chat'e geçildiyse ve boşsa yükle
                    if (iframe && (!iframe.src || iframe.src === window.location.href)) {
                        console.log("   -> Chat Yükleniyor...");
                        iframe.src = chatUrl;
                    }
                } 
                else if (target === 'order') {
                    // Siparişe geçildiyse Chat'i arka planda tutabiliriz
                    // Veya kaynak harcamasın diye silebiliriz (Senin tercihine göre).
                    // Şimdilik sadece gizliyoruz (display:none), böylece konuşma kaybolmaz.
                }
            });
        });

        // 4. SİPARİŞ BUTONU
        const submitBtn = document.getElementById('submitOrderTrackingNew');
        if(submitBtn) {
            const newSubmitBtn = submitBtn.cloneNode(true);
            submitBtn.parentNode.replaceChild(newSubmitBtn, submitBtn);
            newSubmitBtn.addEventListener('click', () => this.submitOrderTrackingInternal());
        }

        this.injectUnifiedStyles();
    }

    // --- CSS (GİZLEME/GÖSTERME İÇİN DÜZENLENDİ) ---
    injectUnifiedStyles() {
        if (document.getElementById('hawk-unified-styles')) return;
        const style = document.createElement('style');
        style.id = 'hawk-unified-styles';
        style.textContent = `
            /* Widget Konteyneri */
            #hawkUnifiedWidget {
                position: fixed;
                bottom: 90px;
                right: 80px;
                width: 380px;
                height: 600px;
                max-height: 75vh;
                background: white;
                border-radius: 16px;
                box-shadow: 0 20px 60px rgba(0,0,0,0.25);
                z-index: 2147483647; 
                display: none; 
                flex-direction: column;
                overflow: hidden;
                opacity: 0;
                transform: translateY(20px) scale(0.95);
                transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
                font-family: 'Poppins', sans-serif;
                border: 1px solid #eee;
            }
            #hawkUnifiedWidget.active { opacity: 1; transform: translateY(0) scale(1); }

            /* Header */
            .hawk-widget-header {
                background: #ffffff;
                border-bottom: 1px solid #f0f0f0;
                padding: 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-shrink: 0;
                height: 60px; box-sizing: border-box;
            }
            
            .hawk-tabs { display: flex; gap: 5px; background: #f4f4f4; padding: 4px; border-radius: 10px; }
            
            .hawk-tab-btn {
                border: none; background: transparent; padding: 8px 16px;
                font-size: 13px; font-weight: 600; color: #888; border-radius: 8px;
                cursor: pointer; transition: all 0.2s;
                    height: 40px !important;

            }
            .hawk-tab-btn.active { background: white; color: #C41414; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
            
            #closeUnifiedBtn { border: none; background: none; font-size: 28px; color: #ccc; cursor: pointer; padding: 0 10px; }
            #closeUnifiedBtn:hover { color: #333; }

            /* --- İÇERİK ALANLARI (KESİN GİZLEME) --- */
            .hawk-tab-content {
                display: none; /* Varsayılan GİZLİ */
                flex: 1;
                width: 100%;
                height: calc(100% - 60px);
                flex-direction: column;
                background: white;
                overflow: hidden;
            }
            
            /* JS ile style.display='flex' verildiğinde bu devreye girer */
            .hawk-tab-content.active {
                animation: fadeIn 0.3s ease;
            }

            /* Chat Iframe */
            #hawkChatFrame { width: 100%; height: 100%; border: none; display: block; }

            /* Sipariş Formu */
            .hawk-order-inner {
                width: 100%; height: 100%; padding: 30px 25px;
                display: flex; flex-direction: column; align-items: center; text-align: center;
                overflow-y: auto; box-sizing: border-box;
            }

            .hawk-order-icon { font-size: 40px; margin-bottom: 15px; }
            .hawk-order-inner h3 { font-size: 20px; margin: 0 0 10px 0; color: #222; }
            .hawk-order-inner p { font-size: 14px; color: #666; margin-bottom: 25px; }
            
            .hawk-input-group { width: 100%; display: flex; flex-direction: column; gap: 10px; margin-bottom: 20px; }
            #hawkOrderInputNew { width: 100%; padding: 14px; border: 2px solid #eee; border-radius: 12px; font-size: 15px; text-align: center; box-sizing: border-box; }
            #submitOrderTrackingNew { width: 100%; padding: 14px; background: #C41414; color: white; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; }
            #hawkOrderResultNew { width: 100%; min-height: 20px; }
            
            .hawk-whatsapp-line { margin-top: auto; padding-top: 30px; width: 100%; border-top: 1px solid #f5f5f5; display: flex; flex-direction: column; align-items: center; gap: 8px; font-size: 12px; color: #999; }
            .hawk-whatsapp-line a { display: flex; align-items: center; gap: 6px; color: #128C7E; font-weight: 600; text-decoration: none; font-size: 14px; background: #e7fceb; padding: 10px 20px; border-radius: 30px; }
            .hawk-whatsapp-line img { width: 20px; }

            @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

            @media (max-width: 480px) {
                #hawkUnifiedWidget { width: 90%; right: 5%; bottom: 100px; height: 70vh; }
            }
        `;
        document.head.appendChild(style);
    }
    // SİPARİŞ SORGULAMA API
    async submitOrderTrackingInternal() {
        const input = document.getElementById('hawkOrderInputNew');
        const resultDiv = document.getElementById('hawkOrderResultNew');
        
        if(!input || !resultDiv) return;
        
        const orderNo = input.value.trim();
        console.log(`   -> Girilen Sipariş No: ${orderNo}`);

        if (!orderNo) { 
            resultDiv.innerHTML = '<span style="color:red; font-size:13px;">Lütfen sipariş numarası giriniz.</span>';
            return; 
        }

        resultDiv.innerHTML = '<div style="color:#666; font-size:13px;">Sorgulanıyor...</div>';
        
        try {
            const proxyUrl = 'https://api.hawkgaming.com.tr/api/proxy';
            console.log("   -> API İsteği Gönderiliyor...");
            
            const response = await fetch(proxyUrl, { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' }, 
                body: JSON.stringify({ endpoint: '/order/detail', body: { OrderNo: orderNo } }) 
            });
            
            const data = await response.json();
            console.log("   -> API Cevabı:", data);

            const item = data.items?.[0];
            
            if (!item) {
                throw new Error("Sipariş bulunamadı.");
            }
            
            // Tarih Formatlama
            let tarihStr = "Belirtilmedi";
            if(item.CreatedDate) {
                const createdDate = new Date(item.CreatedDate);
                const teslimDate = new Date(createdDate);
                teslimDate.setDate(teslimDate.getDate() + 28); 
                tarihStr = teslimDate.toLocaleDateString('tr-TR');
            }

            resultDiv.innerHTML = `
                <div style="background:#f0fdf4; padding:15px; border-radius:10px; border:1px solid #bbf7d0; text-align:left; margin-top:10px;">
                    <p style="margin:0 0 5px; color:#166534; font-size:14px;"><strong>Durum:</strong> ${item._Statu || 'İşlemde'}</p>
                    <p style="margin:0 0 5px; font-size:12px; color:#333;"><strong>Ürün:</strong> ${item._PatternName || 'Özel Tasarım'}</p>
                    <p style="margin:0; font-size:12px; color:#555;"><strong>Tahmini Teslim:</strong> ${tarihStr}</p>
                </div>
            `;
        } catch (err) { 
            console.error("   ❌ Sorgu Hatası:", err);
            resultDiv.innerHTML = `<div style="background:#fef2f2; padding:10px; border-radius:8px; border:1px solid #fecaca; color:#991b1b; margin-top:10px; font-size:13px;">Sipariş bulunamadı. Lütfen numarayı kontrol edin.</div>`; 
        }
    }

    // --- CSS (GARANTİLİ) ---
   

    handleRemoveClick(val) {
        
        let typeKey = "";

        // HTML'deki value değerlerini MaterialManager'ın anladığı dile çevir
        switch(val) {
            case "1": typeKey = "Ön Logo"; break;
            case "2": typeKey = "Arka Logo"; break;
            case "3": typeKey = "Bel Logo"; break;
            case "4": typeKey = "Nickname"; break; // Hem Nickname hem Yastık Logo için ID 4 veya text kontrolü
            case "desen": typeKey = "Desen"; break;
        }

        // Eğer Yastık Logo ise ve value 4 geliyorsa kontrol:
        // (HTML yapına göre bazen yastık logo için ayrı value olmayabilir, 
        // bu durumda o an hangisi aktifse onu sileriz)
        if (val === "4") {
            if (window.yastiklogoyuklendi) typeKey = "Yastık Logo";
            else typeKey = "Nickname";
        }

        if (typeKey === "Desen") {
            // Deseni silmek demek, "Orijinal"e (varsayılan desene) dönmek demektir.
            const originalBtn = document.getElementById("Orijinal");
            if(originalBtn) originalBtn.click();
        } else if (typeKey) {
            // Diğerleri için MaterialManager içindeki temizlik fonksiyonunu çağır
            if(window.hawkMaterials) {
                window.hawkMaterials.rejectSelection(typeKey);
            }
        }
    }
checkOrderStatus() {
        const isValid = this.isOrderValid();
        this.toggleOrderButtons(isValid);

        const g = this.globals;
        // Fiyat görseli güncellemesi (Data bozulmadan)
        this.updatePriceListVisuals(
            g.onlogoyuklendi, 
            g.arkalogoyuklendi, 
            g.bellogoyuklendi, 
            g.yastiklogoyuklendi, 
            g.nicknameyuklendi
        );
    }
isOrderValid() {
        const g = this.globals;
        const currentCategory = (g.cinsbutton && g.cinsbutton[0]) ? g.cinsbutton[0] : "future";
        const currentPattern = (g.tasarimismi && g.tasarimismi[0]) ? g.tasarimismi[0] : "Orijinal";

        // Flagler
        const hasFront = g.onlogoyuklendi === true;
        const hasBack = g.arkalogoyuklendi === true;
        const hasWaist = g.bellogoyuklendi === true;
        const hasPillow = g.yastiklogoyuklendi === true;
        const hasNick = g.nicknameyuklendi === true;

        // 1. Aksesuar Kontrolü
        if (currentCategory === "aksesuar") {
            // En az bir özelleştirme olmalı
            return (hasFront || hasBack || hasWaist || hasPillow || hasNick);
        }

        // 2. Koltuk Kontrolü
        if (currentPattern !== "Orijinal") {
            return true; // Desen seçiliyse geçerli
        } else {
            // Orijinal (Desensiz) ise Gövde Logosu ŞART
            if (hasFront || hasBack || hasWaist) {
                return true;
            }
            // Sadece Yastık veya İsim YETMEZ -> FALSE
            return false;
        }
    }
    // -------------------------------------------------------
    // SİPARİŞ KONTROLÜ (VALIDASYON MANTIĞI)
    // -------------------------------------------------------
    checkOrderStatus() {
        // Motoru sor: Geçerli mi?
        const isValid = this.isOrderValid();

        // UI'ı güncelle (Butonları aç/kapa görsel olarak)
        this.toggleOrderButtons(isValid);

        // Fiyat görsellerini güncelle
        const g = this.globals;
        this.updatePriceListVisuals(
            g.onlogoyuklendi, 
            g.arkalogoyuklendi, 
            g.bellogoyuklendi, 
            g.yastiklogoyuklendi, 
            g.nicknameyuklendi
        );
    }

    toggleOrderButtons(isValid) {
        const desktopBtn = document.getElementById("siparis-button");
        const mobileBtn = document.getElementById("siparis-button2");
        const btns = [desktopBtn, mobileBtn];

        btns.forEach(btn => {
            if (btn) {
                if (isValid) {
                    btn.style.opacity = "1";
                    btn.style.pointerEvents = "all";
                    btn.style.cursor = "pointer";
                } else {
                    btn.style.opacity = "0.2";
                    btn.style.pointerEvents = "none";
                    btn.style.cursor = "not-allowed";
                }
            }
        });
    }

    updatePriceListVisuals(front, back, waist, pillow, nick) {
        // Helper: Bir fiyat kutusunun aktiflik durumunu yönetir
        const setVisual = (id, isActive) => {
            const el = document.getElementById(id);
            if (!el) return;
            
            // Burada sadece class değişimi yapıyoruz, içeriği veya fiyatı bozmuyoruz.
            // Dolu ise 'black' classı ekleniyor (siyah arka plan vb.), boşsa siliniyor.
            if (isActive) {
                el.classList.remove('active');
                el.classList.add('black');
                el.style.display = 'flex'; // Doluysa kesin göster
            } else {
                // Eğer desen kısıtlamasından dolayı gizlenmemişse active moduna dön
                if(el.style.display !== 'none') {
                    el.classList.add('active');
                    el.classList.remove('black');
                }
            }
        };

        setVisual("onfiyati", front);
        setVisual("arkafiyati", back);
        setVisual("belfiyati", waist);
        
        // Yastık ve İsim aynı kutuyu (isimfiyati) paylaşabilir duruma göre
        // ama senin HTML yapında bu ikisi dinamik yönetiliyor.
        // Eğer ikisinden biri varsa o kutu aktiftir.
        setVisual("isimfiyati", (pillow || nick));
    }
    // -------------------------------------------------------
    // 1. BUTON GÖRÜNÜRLÜĞÜ (GERİ GETİRİLDİ)
    // -------------------------------------------------------
    updateButtonVisibility(currentDesenAdi) {
        /* console.group(`👁️ [UI] Buton Kontrolü: "${currentDesenAdi}"`); */
        
        // 1. Butonları Tanımla
        const buttons = {
            "ön": document.getElementById("önLogoEkle"),
            "arka": document.getElementById("arkaLogoEkle"),
            "bel": document.getElementById("belLogoEkle"),
            "yastık": document.getElementById("yastikLogoEkle"),
            "nick": document.getElementById("isimYazdirma")
        };

        // 2. Hepsini AÇ (Reset)
        Object.values(buttons).forEach(btn => { 
            if(btn) btn.style.display = 'block'; 
        });

        // 3. Kural Kontrolü (HawkProductLogic'den gelen veri)
        const supported = window.desteklenenDesenler || {};
        const rules = supported[currentDesenAdi];

        if (rules) {
            // console.log(`📋 Gizlenecekler:`, rules);
            rules.forEach(key => {
                if (buttons[key]) {
                    buttons[key].style.display = 'none';
                    // Verileri Sıfırla (Opsiyonel, Logic zaten hallediyor ama UI temizliği için iyi)
                    this.resetAssociatedData(key);
                }
            });
        } else {
            // console.warn(`⚠️ "${currentDesenAdi}" için kural bulunamadı!`);
        }
        
        // Helper reset
        this.helperActiveReset(0);
        if(typeof checksiparis === 'function') checksiparis();
        // console.groupEnd();
    }

    resetAssociatedData(key) {
        // Buton gizlendiğinde ilgili veriyi temizle
        if (key === "ön") { window.onlogoyuklendi = false; window.resultonlogo = []; }
        else if (key === "arka") { window.arkalogoyuklendi = false; window.resultarkalogo = []; }
        else if (key === "bel") { window.bellogoyuklendi = false; window.resultbellogo = []; }
        else if (key === "yastık") { window.yastiklogoyuklendi = false; window.resultyastiklogo = []; }
        else if (key === "nick") { window.nicknameyuklendi = false; }
    }

    helperActiveReset(index) {
        const color = document.getElementById("input-color-container"); 
        const nick = document.getElementById("nickname");
        // Eğer reset modundaysak (index 0) veya alakasız bir moddaysak gizle
        if(index === 0 || index === 2 || index === 3 || index === 1 || index === 5) { 
            // Bu elemanlar zaten dynamic area içinde yönetiliyor ama
            // statik kalanlar varsa diye güvenlik önlemi:
            if(color) color.style.display = 'none'; 
            if(nick) nick.style.display = 'none'; 
        }
    }

    // -------------------------------------------------------
    // 2. UI MOD YÖNETİMİ (MOBİL FİYAT BUTONU FIX)
    // -------------------------------------------------------
    setUIMode(mode) {
        const elementsToControl = [
            'other-selection-options active',
            'title-containerUrunler',
            'patterns-container',
            'siparis-button',
            'siparis-button2', 
            'mobile-create-order'
        ];

        const selectionButtons = document.querySelectorAll('.selection-button');
        const confirmDiv = document.getElementById('siparis-onay');
        const viewPriceBtn = document.querySelector('.view-price'); // Mobil Fiyat Butonu

        if (mode === 'active') {
            // --- ODAK MODU (GİZLE) ---
            elementsToControl.forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    if (id === 'other-selection-options active' || id === 'title-containerUrunler') {
                        el.style.visibility = 'hidden'; 
                        el.style.opacity = '0';
                        el.style.pointerEvents = 'none';
                    } else {
                        el.style.display = 'none'; 
                    }
                }
            });

            // Mobil "Fiyatı Gör" butonunu gizle
            if (viewPriceBtn) viewPriceBtn.style.display = 'none';

            selectionButtons.forEach(btn => {
                btn.classList.remove('active');
                btn.style.opacity = '0'; 
                btn.style.pointerEvents = 'none';
            });

            if(confirmDiv) {
                confirmDiv.style.display = 'flex';
                confirmDiv.style.opacity = '1';
                confirmDiv.style.pointerEvents = 'all';
            }

        } else {
            // --- NORMAL MOD (GÖSTER) ---
            elementsToControl.forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    el.style.visibility = 'visible';
                    el.style.opacity = '1';
                    el.style.pointerEvents = 'all';
                    
                    if (id === 'patterns-container') el.style.display = 'flex';
                    else if (id === 'siparis-button') el.style.display = 'block';
                    else if (id === 'siparis-button2') el.style.display = ''; // CSS'e bırak
                    else el.style.display = ''; 
                }
            });

            // Mobil "Fiyatı Gör" butonunu geri getir
            if (viewPriceBtn) viewPriceBtn.style.display = ''; // CSS'e bırak

            selectionButtons.forEach(btn => {
                btn.style.opacity = '1';
                btn.style.pointerEvents = 'all';
                btn.classList.remove('active');
            });

            if(confirmDiv) confirmDiv.style.display = 'none';
        }
    }

    // -------------------------------------------------------
    // 3. UYARI MODALI (ESKİ İÇERİK GERİ GELDİ)
    // -------------------------------------------------------
    createWarningModal() {
        if (document.getElementById('hawkWarningModal')) return;
        const overlay = document.createElement('div');
        overlay.id = 'hawkWarningModal';
        overlay.className = 'hawk-warning-overlay';
        overlay.innerHTML = `
            <div class="hawk-warning-content">
                <p class="hawk-modal-title">Dikkat! Önemli Bilgi</p>
                <div id="hawkWarningPrice" class="hawk-warning-price"></div>
                <ul class="hawk-warning-list">
                    <li>Özel tasarım işleminde nakış uygulaması yapılacağından dolayı renk geçişlerinde ve detaylı tasarımlarda farklılık gösterebilir.</li>
                    <li>Özel tasarım siparişiniz onaylandıktan sonra tasarım değişikliği yapılmamaktadır.</li>
                    <li>Logonuzu yüksek çözünürlüklü <strong>300px - 4096px</strong> arası PNG dosyası olarak yükleyiniz.</li>
                    <li>Telif hakkı başkasına ait logoları yüklemeyiniz.</li>
                    <li>Hawk Gaming Chair uygunsuz gördüğü logoları reddetme hakkına sahiptir.</li>
                </ul>
                <p class="hawk-sub-title">YASAL UYARI!</p>
                <p class="hawk-warning-text">Markamız din, dil ve ırka aykırı uygunsuz logoları reddetme hakkına sahiptir. Ayrıca özel tasarımlı oyuncu koltuğu siparişinin iptali ve iadesi kabul edilmemektedir.</p>
                <div class="hawk-warning-buttons">
                    <button class="hawk-btn-cancel" id="hawkModalCancel">Vazgeç</button>
                    <button class="hawk-btn-confirm" id="hawkModalConfirm">Okudum, Devam Et</button>
                </div>
            </div>
        `;
        document.body.appendChild(overlay);
        document.getElementById('hawkModalCancel').addEventListener('click', () => this.hideWarningModal(false));
        document.getElementById('hawkModalConfirm').addEventListener('click', () => this.hideWarningModal(true));
    }

    // -------------------------------------------------------
    // 4. STİL ENJEKSİYONU (GÜNCELLENDİ)
    // -------------------------------------------------------
    injectStyles() {
        const styleId = 'hawk-ui-styles';
        if (document.getElementById(styleId)) return;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            /* --- GENEL DÜZENLEMELER --- */
            .other-customize-options { 
                position: relative; 
                display: flex; 
                flex-direction: column; 
                gap: 15px; 
                width: 100%;
                justify-content: center;
            }
                #title-containerUrunler {
             
                pointer-events: none !important; 
            }
             .reset-button {
                z-index: 100 !important;
                position: relative;
                cursor: pointer;
                pointer-events: auto !important; /* Reset butonu her zaman tıklanabilsin */
            }
            /* --- NICKNAME ALANI --- */
            #nickname { 
                width: 100% !important; 
                height: 50px !important; 
                border-radius: 50px !important; 
                padding-left: 65px !important; 
                pointer-events: auto !important; 
                z-index: 100 !important; 
                border: 2px solid #e0e0e0 !important;
                
                /* --- KRİTİK GÜNCELLEMELER BURADA --- */
                font-family: 'Anton', sans-serif !important; /* Sadece Anton fontu */
                text-transform: uppercase !important;        /* Görsel olarak hep büyük */
                font-size: 18px !important;                  /* Okunaklı boyut */
                letter-spacing: 1px !important;              /* Harf aralığı */
                /* ------------------------------------ */

                font-weight: 400; /* Anton zaten bold karakterlidir */
                background: #fff; 
                opacity: 1 !important; 
                color: black;
                margin-bottom: 0;
            }

            /* Renk Kapsayıcısı */
            #input-color-container { 
                position: absolute !important; 
                left: 5px !important; 
                top: 50% !important; 
                transform: translateY(-50%) !important; /* Dikey ortalama */
                width: 40px !important; 
                height: 40px !important; 
                border-radius: 50% !important; 
                z-index: 102 !important; 
                display: flex !important; /* None kaldırıldı */
                align-items: center;
                justify-content: center;
                cursor: pointer; 
                overflow: hidden;
                box-shadow: 0 2px 5px rgba(0,0,0,0.2);
            }

            #nicknameColor { 
                width: 150%; 
                height: 150%; 
                opacity: 0; 
                cursor: pointer; 
                position: absolute; 
                top: -10px; left: -10px;
                pointer-events: auto !important; 
            }

            /* Dosya Yükleme Alanı */
            .upload-file-container {
                border: 2px dashed #ccc;
                background: rgba(255,255,255,0.5);
                border-radius: 15px;
                transition: 0.3s;
            }
            .highlight { 
                border-color: #C41414 !important; 
                background-color: rgba(196, 20, 20, 0.05) !important; 
            }

            /* --- MODERN ONAY BUTONLARI --- */
            .siparis-onay {
                display: flex;
                gap: 10px;
                width: 100%;
                margin-top: 15px;
                justify-content: space-between;
                padding-bottom: 10px;
            }

            .siparis-onay button {
                flex: 1;
                padding: 12px 0;
                border-radius: 50px;
                font-weight: 600;
                font-size: 14px;
                cursor: pointer;
                border: none;
                transition: transform 0.2s, box-shadow 0.2s;
                text-transform: uppercase;
                letter-spacing: 0.5px;
            }

            .siparis-onay .reddet {
                background-color: #f1f1f1;
                color: #333;
                border: 1px solid #ddd;
            }
            .siparis-onay .onayla {
                background-color: #C41414;
                color: white;
                box-shadow: 0 4px 10px rgba(196, 20, 20, 0.3);
            }
            
            .siparis-onay button:active { transform: scale(0.95); }

            /* --- UYARI MODALI --- */
            .hawk-warning-overlay { 
                position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
                background: rgba(0, 0, 0, 0.85); z-index: 99999; 
                display: none; align-items: center; justify-content: center; 
                opacity: 0; transition: opacity 0.3s ease; backdrop-filter: blur(5px); 
            }
            .hawk-warning-overlay.active { display: flex; opacity: 1; }
            
            .hawk-warning-content { 
                background: #1f1f1f; 
                border-radius: 16px; 
                width: 90%; 
                max-width: 550px; /* Eski genişlik */
                padding: 10px; 
                border: 1px solid rgba(255,255,255,0.1); 
                box-shadow: 0 25px 50px rgba(0,0,0,0.5); 
                color: white; 
                font-family: 'Poppins', sans-serif; 
                max-height: 90vh; 
                overflow-y: auto; 
            }
                /* HawkUIController.js -> injectStyles içine ekle: */


            #loadingbar {
                display: none; /* Başlangıçta gizli */
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 50; /* Modelin üstünde, menülerin altında */
                background: rgba(255, 255, 255, 0.8); /* Hafif transparan beyaz kutu */
                padding: 15px;
                border-radius: 50%; /* Yuvarlak kutu */
                box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                width: 60px;
                height: 60px;
                align-items: center;
                justify-content: center;
            }

            #loadingbar img {
                width: 30px;
                height: 30px;
                object-fit: contain;
            }
            .hawk-modal-title { 
                color: #C41414; font-size: 22px; font-weight: 700; 
                margin-bottom: 20px; text-align: center; letter-spacing: 1px; 
            }
            
            .hawk-warning-list { 
                list-style: none; padding: 0; margin: 0 0 20px 0; 
                color: #ddd; font-size: 13px; line-height: 1.6; 
            }
            .hawk-warning-list li { margin-bottom: 10px; padding-left: 20px; position: relative; }
            .hawk-warning-list li::before { content: "•"; color: #C41414; position: absolute; left: 0; font-weight: bold; }
            
            .hawk-sub-title { 
                color: #C41414; font-size: 16px; font-weight: 700; 
                margin-bottom: 10px; text-transform: uppercase; 
            }
            
            .hawk-warning-text { 
                color: #ccc; font-size: 13px; line-height: 1.5; margin-bottom: 30px; 
                text-align: justify; background: rgba(255,255,255,0.05); 
                padding: 15px; border-radius: 8px; 
            }
            
            .hawk-warning-buttons { display: flex; gap: 15px; justify-content: center; }
            
            .hawk-btn-cancel { background: transparent; border: 2px solid #555; color: #ccc; padding: 12px 30px; border-radius: 50px; cursor: pointer; font-weight: 600; transition: 0.2s; font-size: 14px; }
            .hawk-btn-cancel:hover { border-color: #ccc; color: white; }
            .hawk-btn-confirm { background: #C41414; border: 2px solid #C41414; color: white; padding: 12px 40px; border-radius: 50px; cursor: pointer; font-weight: 600; transition: 0.2s; font-size: 14px; }
            .hawk-btn-confirm:hover { background: #a00000; border-color: #a00000; transform: scale(1.05); box-shadow: 0 5px 15px rgba(196, 20, 20, 0.3); }
        `;
        document.head.appendChild(style);
    }
    
    // Uyarı penceresindeki fiyat kartı.
    // Fiyatlar API'den gelen window.customfiyatlar dizisinden okunuyor
    // (HawkProductLogic /common/definedetails ile dolduruyor) — burada
    // hiçbir tutar sabitlenmiyor, tek doğruluk kaynağı yine API.
    // activeOptionIndex, updateActiveOption içinde showWarningModal'dan
    // ÖNCE atandığı için burada güvenle okunabiliyor.
    static get NAKIS_BOLGELERI() {
        return {
            1: { etiket: 'Ön Sırt Nakışı',    fiyatBasligi: 'Ön Logo' },
            2: { etiket: 'Arka Sırt Nakışı',  fiyatBasligi: 'Arka Logo' },
            3: { etiket: 'Bel Desteği Nakışı', fiyatBasligi: 'Bel Logo' },
            4: { etiket: 'İsim Yazdırma',     fiyatBasligi: 'Nickname' },
            5: { etiket: 'Yastık Logo',       fiyatBasligi: 'Üst Yastık Logo' }
        };
    }

    static fiyatMetni(baslik) {
        if (!window.customfiyatlar) return null;
        const kayit = window.customfiyatlar.find(x => x.Title === baslik);
        if (!kayit) return null;
        const sayi = parseFloat(String(kayit.Description).replace(/\./g, '').replace(',', '.').trim());
        if (!isFinite(sayi)) return null;
        return sayi.toLocaleString('tr-TR') + ' ₺';
    }

    yazFiyatKarti() {
        const kutu = document.getElementById('hawkWarningPrice');
        if (!kutu) return;
        const bolge = HawkUIController.NAKIS_BOLGELERI[this.activeOptionIndex];
        const fiyat = bolge ? HawkUIController.fiyatMetni(bolge.fiyatBasligi) : null;

        // Fiyat henüz gelmediyse kartı hiç gösterme; yanlış/boş tutar yazmaktansa
        // hiç yazmamak doğru.
        if (!bolge || !fiyat) { kutu.style.display = 'none'; kutu.innerHTML = ''; return; }

        kutu.style.display = 'flex';
        kutu.innerHTML =
            `<span class="hawk-warning-price__ad">${bolge.etiket}</span>` +
            `<span class="hawk-warning-price__tutar">+${fiyat}</span>`;
    }

    showWarningModal(onConfirmAction) {
        this.pendingAction = onConfirmAction;
        this.yazFiyatKarti();
        const modal = document.getElementById('hawkWarningModal');
        if(modal) { modal.style.display = 'flex'; setTimeout(() => modal.classList.add('active'), 10); }
    }
    
    hideWarningModal(isConfirmed) {
        const modal = document.getElementById('hawkWarningModal');
        if(modal) {
            modal.classList.remove('active');
            setTimeout(() => {
                modal.style.display = 'none';
                if (isConfirmed) { if (this.pendingAction) this.pendingAction(); } 
                else { this.resetUI(); }
                this.pendingAction = null;
            }, 300);
        }
    }

    initEventListeners() {
        this.bindButton('önLogoEkle', 1);
        this.bindButton('arkaLogoEkle', 2);
        this.bindButton('belLogoEkle', 3);
        this.bindButton('isimYazdirma', 4);
        this.bindButton('yastikLogoEkle', 5);

        const resetBtn = document.getElementById('resetButton');
        if (resetBtn) resetBtn.addEventListener('click', () => this.resetUI(true));

        // Mobil Sipariş Butonu
        const mobileOrderBtn = document.getElementById('siparis-button2');
        if (mobileOrderBtn) {
            mobileOrderBtn.addEventListener('click', (e) => {
                e.preventDefault(); // Varsayılanı durdur
                
                // --- GÜVENLİK DUVARI BURADA ---
                if (this.isOrderValid()) {
                    if(typeof checkoutManager !== 'undefined') checkoutManager.open();
                } else {
                    alert("Sipariş verebilmek için lütfen bir desen seçiniz veya koltuğun gövdesine (Ön/Arka/Bel) logo ekleyiniz.");
                }
            });
        }

        const dropArea = document.getElementById('uploadFileContainer');
        if(dropArea) {
            dropArea.addEventListener('dragover', (e) => { e.preventDefault(); dropArea.classList.add('highlight'); });
            dropArea.addEventListener('dragleave', (e) => { e.preventDefault(); dropArea.classList.remove('highlight'); });
            dropArea.addEventListener('drop', (e) => this.handleDrop(e));
        }

        // HawkUIController.js -> initEventListeners içine:

    const infoBtn = document.getElementById('howToUseBtn');
    const infoOverlay = document.getElementById('infoModalOverlay'); // Bu div HTML'de olmalı (Footer adımında eklemiştik)
    
    if(infoBtn && infoOverlay) {
        infoBtn.addEventListener('click', () => {
            infoOverlay.style.display = 'block';
        });
        // Modalı kapatma (X butonu veya dışına tıklama)
        infoOverlay.addEventListener('click', (e) => {
            if(e.target === infoOverlay || e.target.id === 'closeInfoModal') {
                infoOverlay.style.display = 'none';
            }
        });
    }}
    
    // ... Diğer fonksiyonlar (initCustomizationArea, updateActiveOption, renderUploadMode, renderNicknameMode, renderConfirmButtons, resetUI, handleDrop, handleFileSelect, processUploadedFile, triggerNicknameUpdate, applyToMaterial, triggerMaterialPopup, initOrderTracking, submitOrderTracking, initDarkMode, applyDarkModeStyles, initMobileUI, toggleMobileZIndex)
    // Bu fonksiyonların hepsi bir önceki versiyondaki gibi KALMALI. Dosya boyutunu şişirmemek için tekrar yazmadım ama sen hepsini birleştirdiğinden emin ol.
    
    // --- BU KISIMLARI DAHA ÖNCEKİ CEVAPLARDAN EKSİKSİZ ALARAK BİRLEŞTİR ---
    // 1. initCustomizationArea
    initCustomizationArea() {
        const container = document.getElementById('dynamic-customization-area');
        if (!container) return;
        container.innerHTML = ''; 
        
        const orderBtn = document.createElement('button');
        orderBtn.id = 'siparis-button';
        orderBtn.className = 'create-order-button';
        orderBtn.innerText = 'Sipariş Oluştur';
        
        // --- GÜVENLİK DUVARI BURADA ---
        orderBtn.onclick = () => { 
            if (this.isOrderValid()) {
                // Geçerli -> Kasayı Aç
                if(typeof checkoutManager !== 'undefined') checkoutManager.open();
            } else {
                // Geçersiz -> Uyarı Ver (CSS hilesi yapsa bile buraya düşer)
                alert("Sipariş verebilmek için lütfen bir desen seçiniz veya koltuğun gövdesine (Ön/Arka/Bel) logo ekleyiniz.\n\nSadece İsim veya Yastık Logosu ile sipariş verilememektedir.");
            }
        };
        
        container.appendChild(orderBtn);
        if(typeof checksiparis === 'function') checksiparis();
    }
    
    // 2. updateActiveOption
    // HawkUIController.js -> updateActiveOption GÜNCELLEMESİ

    updateActiveOption(index) {
        this.activeOptionIndex = index;
        window.activeOptionIndex = index;
        
        const viewer = document.getElementById("hawkgamingchair");
        if(!viewer) return;

        if (index !== 0) { 
            this.setUIMode('active'); 
        } else { 
            this.setUIMode('passive'); 
            this.initCustomizationArea(); 
        }

        // Helper: Kamera Ayarla
        const setCam = (orbit, fov, target) => { 
            viewer.cameraOrbit = orbit; 
            viewer.fieldOfView = fov; 
            viewer.cameraTarget = target; 
        };

        const isAksesuar = this.globals.cinsbutton && this.globals.cinsbutton.includes("aksesuar");
        const modelName = (this.globals.tasarimismiKontrol && this.globals.tasarimismiKontrol[0]) ? this.globals.tasarimismiKontrol[0] : "";

        switch (index) {
            case 0: // Reset
                setCam("30deg 75deg 105%", "auto", "auto auto auto"); 
                break;
            case 1: // Ön
                setCam("-2180deg 89.1deg 3.441m", "17.6deg", "-0.02m 1.01m -0.17m"); 
                this.showWarningModal(() => { this.renderUploadMode("Ön Logo", "Ön Logo"); }); 
                break;
            case 2: // Arka
                setCam("-2352deg 87.14deg 3.156m", "27.6deg", "-0.02m 0.71m -0.17m"); 
                this.showWarningModal(() => { this.renderUploadMode("Arka Logo", "Arka Logo"); }); 
                break;
            case 3: // Bel Logo
                if (isAksesuar) {
                    // Güvenli kontrol (includes ile)
                    if (modelName.includes("Fab Bel")) {
                        // Fab Bel Yastık Kamerası
                        setCam("-20.19deg 81.86deg 0.7109m", "30deg", "-0.01m 0.12m 0.04m");
                    } 
                    else if (modelName.includes("Future Bel")) {
                        // Future Bel Yastık Kamerası
                        setCam("-12.19deg 79.1deg 1.738m", "30deg", "0.02m 0.35m -0.04m");
                    }
                    else {
                        // Varsayılan Aksesuar Kamerası (Güvenlik)
                        setCam("auto", "auto", "auto");
                    }
                } else {
                    // Standart Koltuklar
                    setCam("-2160deg 89.1deg 3.441m", "12.6deg", "-0.02m 0.71m -0.17m");
                }
                this.showWarningModal(() => { this.renderUploadMode("Bel Logo", "Bel Logo"); }); 
                break;
            case 4: // Nickname
                if (isAksesuar) setCam("-12.18deg 85.36deg 1.284m", "30deg", "-0.06m 0.18m 0.15m"); 
                else setCam("15.89deg 96.31deg 1.894m", "13.5deg", "0.02m 1.26m -0.11m");
                this.showWarningModal(() => { this.renderNicknameMode(); }); 
                break;
            case 5: // Yastık Logo
                if (isAksesuar) setCam("-12.18deg 85.36deg 1.284m", "30deg", "-0.06m 0.18m 0.15m"); 
                else setCam("15.89deg 96.31deg 1.894m", "13.5deg", "0.02m 1.26m -0.11m");
                this.showWarningModal(() => { this.renderUploadMode("Yastık Logo", "Yastık Logo"); }); 
                break;
        }
    }
    
    // 3. resetUI
    // -------------------------------------------------------
    // RESET UI (DISPLAY FIX & HARD RESET)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // RESET UI (HARD RESET: DATA, FİYAT VE 3D MODEL TEMİZLİĞİ)
    // -------------------------------------------------------
    // HawkUIController.js -> resetUI GÜNCELLEMESİ

   async resetUI(isHardReset = false) { // async yaptık ki revert işlemleri sırayla yapılsın
    // 1. Arayüzü Toparla (Kamera ve menüleri varsayılana çek)
    this.updateActiveOption(0); 
    this.initCustomizationArea();
    
    // Inputları Temizle
    const fileInput = document.getElementById('inputfile'); if(fileInput) fileInput.value = "";
    const nickInput = document.getElementById('nickname'); if(nickInput) nickInput.value = "";

    // SADECE ÇÖP KUTUSU / RESET BUTONU (HARD RESET)
    if (isHardReset === true) {
        console.warn("⚠️ HARD RESET: Model ve Veriler sıfırlanıyor...");

        // A) GLOBAL DEĞİŞKENLERİ SIFIRLA
        window.onlogoyuklendi = false;
        window.arkalogoyuklendi = false;
        window.bellogoyuklendi = false;
        window.yastiklogoyuklendi = false;
        window.nicknameyuklendi = false;
        
        window.resultonlogo = [];
        window.resultarkalogo = [];
        window.resultbellogo = [];
        window.resultyastiklogo = [];
        window.logorenk = ["#ffffff"];

        // B) LEGACY DATA SIFIRLA
        if(window.siparis_data) {
            window.siparis_data.nickname = ["yok"];
            window.siparis_data.nicknamecolor = ["#ffffff"];
            window.siparis_data.on_logo = ["yok"];
            window.siparis_data.arka_logo = ["yok"];
            window.siparis_data.bel_logo = ["yok"];
            window.siparis_data.yastik_logo = ["yok"];
            // Fiyat verileri
            window.siparis_data.onfiyat = ["0"];
            window.siparis_data.arkafiyat = ["0"];
            window.siparis_data.belfiyat = ["0"];
            window.siparis_data.nickfiyat = ["0"];
            window.siparis_data.desenfiyat = ["0"];
        }

        // C) ORDER DATA SIFIRLA (API)
        if(window.orderData) {
            window.orderData.PaymentAmount = 0;
            if (window.orderData.Features) {
                if(window.orderData.Features.Patterns) {
                    window.orderData.Features.Patterns.Front = "";
                    window.orderData.Features.Patterns.Back = "";
                    window.orderData.Features.Patterns.Waist = "";
                }
                if(window.orderData.Features.Nickname) {
                    window.orderData.Features.Nickname.Text = "";
                    window.orderData.Features.Nickname.Color = "#ffffff";
                }
            }
        }

        // D) UI FİYATLARI VE X BUTONLARINI SIFIRLA
        ['onfiyati', 'arkafiyati', 'belfiyati', 'isimfiyati'].forEach(id => {
            const el = document.getElementById(id);
            if(el) {
                el.classList.remove('black'); 
                el.classList.add('active');   
                el.style.display = ''; 
                
                const span = el.querySelector('span');
                if(span) span.innerText = "0 ₺";

                const removeBtn = el.querySelector('.remove-button');
                if(removeBtn) removeBtn.style.display = 'none';
            }
        });

        // E) TOPLAM FİYATI YENİLE
        if(typeof updateTotalPrice === 'function') updateTotalPrice();

        // F) MODELİ YENİDEN YÜKLE (VISUAL RESET)
        if (window.hawkMaterials) {
            // window.hawkMaterials.restoreInitialState(); // Eski yöntem (Yetersiz kalıyor)

            // 👇 KESİN ÇÖZÜM: Yeni yazdığımız akıllı revert fonksiyonlarını çağırıyoruz 👇
            console.log("♻️ ResetUI: Tüm bölgeler fabrika ayarlarına dönüyor...");
            
            // Yastık/Nickname için (Index bazlı çalışır, kesin çözer)
            await window.hawkMaterials.revertTexture("Yastık Logo"); 
            
            // Bel Logo için (API Link bazlı çalışır)
            await window.hawkMaterials.revertTexture("Bel Logo");
            
            // Diğerleri için (Standart)
            await window.hawkMaterials.revertTexture("Ön Logo");
            await window.hawkMaterials.revertTexture("Arka Logo");
        }
        
        // G) Ürün Logic'ini Resetle
        if(window.hawkProduct) window.hawkProduct.resetCategoryState();
        
        // H) "Orijinal" butonuna tıklat (Varsayılan desene dön - Garantileme)
        setTimeout(() => {
            if(this.globals.cinsbutton && this.globals.cinsbutton.includes("aksesuar")) { 
                const coal = document.getElementById("Coal") || document.querySelector(".pattern-content"); 
                if(coal) coal.click(); 
            } else { 
                const orij = document.getElementById("Orijinal"); 
                if(orij) orij.click(); 
            }
        }, 150); // Süreyi biraz arttırdım (100 -> 150) ki revert işlemleri çakışmasın
    }
}
    
    // 4. renderUploadMode
    renderUploadMode(title, typeKey) {
        const container = document.getElementById('dynamic-customization-area');
        if (!container) return;
        
        // --- KRİTİK: Durumu Sıfırla ---
        this.isFileUploadedSuccess = false; 
        // ------------------------------

        container.innerHTML = '';
        const optionsDiv = document.createElement('div');
        optionsDiv.className = 'other-customize-options';
        
        const uploadLabel = document.createElement('label');
        uploadLabel.className = 'upload-file-container';
        uploadLabel.id = 'uploadFileContainer';
        uploadLabel.style.width = '100%';
        
        uploadLabel.innerHTML = `
            <span id="filename" class="filename">${title} İçin Dosya Seç</span>
            <input id="inputfile" type="file" class="inputfile form-control" name="file" accept="image/png, image/jpeg, image/webp">
        `;
        uploadLabel.style.pointerEvents = 'all';
        uploadLabel.style.opacity = '1';
        const fileInput = uploadLabel.querySelector('input');
        fileInput.addEventListener('change', (e) => this.handleFileSelect(e));
        
        // Drag & Drop
        uploadLabel.addEventListener('dragover', (e) => { e.preventDefault(); uploadLabel.classList.add('highlight'); });
        uploadLabel.addEventListener('dragleave', (e) => { e.preventDefault(); uploadLabel.classList.remove('highlight'); });
        uploadLabel.addEventListener('drop', (e) => this.handleDrop(e));
        
        optionsDiv.appendChild(uploadLabel);
        container.appendChild(optionsDiv);
        
        this.renderConfirmButtons(container, typeKey);
        
        // Mobilde klavyeyi/dosyayı hemen açma, kullanıcı tıklasın (UX)
         setTimeout(() => { fileInput.click(); }, 200); 
    }
    
    // 5. renderNicknameMode
    // HawkUIController.js -> renderNicknameMode GÜNCELLEMESİ

    // HawkUIController.js -> renderNicknameMode (RENK ENTEGRASYONLU)

    // -------------------------------------------------------
    // NICKNAME INPUT ALANI (BASE64 FİLTRELİ)
    // -------------------------------------------------------
    renderNicknameMode() {
        this.globals.yastiklogoyuklendi = false; 
        this.globals.resultyastiklogo = []; // Eski resmi de temizle
        if(typeof updateTotalPrice === 'function') updateTotalPrice(); // Fiyatı anlık düşür (0 TL)
        if(window.guncelleFiyat) window.guncelleFiyat('nick'); // Kutuyu güncelle
        
        // ----------------------------------------

        const container = document.getElementById('dynamic-customization-area');
        if (!container) return;
        container.innerHTML = '';
        
        const optionsDiv = document.createElement('div');
        optionsDiv.className = 'other-customize-options';
        
        // 1. BAŞLANGIÇ RENGİ
        let initialColor = "#ffffff";
        if (window.orderData && window.orderData.Features && window.orderData.Features.Nickname && window.orderData.Features.Nickname.Color) {
            initialColor = window.orderData.Features.Nickname.Color;
        } else if (window.logorenk && window.logorenk[0]) {
            initialColor = window.logorenk[0];
        }

        const colorDiv = document.createElement('div');
        colorDiv.id = 'input-color-container';
        colorDiv.innerHTML = `<img style="width: 30px; height: 30px; pointer-events: none;" src="/static/image/colorpicker.png"><input id="nicknameColor" value="${initialColor}" type="color">`;
        
        const colorInput = colorDiv.querySelector('input');
        colorInput.addEventListener('input', (e) => {
             const newColor = e.target.value;
             const nickInput = document.getElementById('nickname');
             
             window.logorenk = [newColor];
             if(window.updateOrderJson) window.updateOrderJson(newColor, "Features.Nickname.Color");
             if(window.siparis_data) window.siparis_data.nicknamecolor = [newColor];

             if(nickInput) this.triggerNicknameUpdate(nickInput.value, newColor);
        });
        
        const textInput = document.createElement('input');
        textInput.id = 'nickname';
        textInput.className = 'nickname';
        textInput.placeholder = 'İSİM YAZINIZ'; 
        textInput.type = 'text';
        textInput.maxLength = 10;
        
        // --- KRİTİK DÜZELTME: BASE64 FİLTRESİ ---
        // Veriyi çekiyoruz ama inputa yazmadan önce kontrol ediyoruz.
        let savedText = "";
        
        if (window.orderData?.Features?.Nickname?.Text && window.orderData.Features.Nickname.Text !== "yok") {
             savedText = window.orderData.Features.Nickname.Text;
        } else if (window.siparis_data && window.siparis_data.nickname && window.siparis_data.nickname[0] !== "yok") {
             savedText = window.siparis_data.nickname[0];
        }

        // Eğer veri "data:image" ile başlıyorsa veya "base64" içeriyorsa, bu bir resimdir.
        // INPUT'A YAZMA! (Boş bırak)
        // Eğer normal bir yazıysa INPUT'A YAZ.
        if (savedText && !savedText.startsWith("data:image") && !savedText.includes("base64")) {
            textInput.value = savedText.toUpperCase();
        }
        // ----------------------------------------
        
        textInput.addEventListener('input', (e) => {
             let val = e.target.value;
             val = val.toLocaleUpperCase('tr-TR');
             e.target.value = val;
             
             const currentColor = document.getElementById('nicknameColor')?.value || initialColor;
             this.triggerNicknameUpdate(val, currentColor);
        });

        optionsDiv.appendChild(colorDiv);
        optionsDiv.appendChild(textInput);
        container.appendChild(optionsDiv);
        
        this.renderConfirmButtons(container, "Nickname");
        
        setTimeout(() => textInput.focus(), 200);
    }
    
    // 6. renderConfirmButtons
   // HawkUIController.js -> renderConfirmButtons (FİYAT GÜNCELLEME EKLENDİ)

    // HawkUIController.js -> renderConfirmButtons (VAZGEÇ FİYAT FIX)

    // -------------------------------------------------------
    // ONAY/RED BUTONLARI (FİYAT VE UI FIX)
    // -------------------------------------------------------
    renderConfirmButtons(parentContainer, typeKey) {
        const confirmDiv = document.createElement('div');
        confirmDiv.id = 'siparis-onay';
        confirmDiv.className = 'siparis-onay';
        
        // --- VAZGEÇ BUTONU ---
        const btnCancel = document.createElement('button');
        btnCancel.className = 'reddet';
        btnCancel.innerText = 'VAZGEÇ';
        
        btnCancel.onclick = () => {
            const isNickname = typeKey === "Nickname" || this.activeOptionIndex === 4;
            console.log(this.isFileUploadedSuccess)
            console.log(isNickname)

            // 1. Revert İşlemi (Nickname modunda her zaman çağırıyoruz)
            if ((this.isFileUploadedSuccess || isNickname) && window.hawkMaterials) {
                window.hawkMaterials.revertTexture(typeKey);
            }
            
            // 2. UI'ı Kapat (Fiyatları sıfırlar)
            this.resetUI(); 
            
            // 3. FİYATLARI VE KUTULARI GERİ YÜKLE (Bayraklara göre doğru fiyatı tekrar yazar)
            setTimeout(() => {
               

                if (typeof updateTotalPrice === 'function') updateTotalPrice();
                
                if (typeof guncelleFiyat === 'function') {
                    ['koltuk', 'ön', 'arka', 'bel', 'desen', 'nick'].forEach(type => guncelleFiyat(type));
                }
            }, 50); 
        };

        // --- ONAYLA BUTONU ---
        const btnConfirm = document.createElement('button');
        btnConfirm.className = 'onayla';
        btnConfirm.innerText = 'ONAYLA';
        
        btnConfirm.onclick = () => {
            const isNicknameMode = typeKey === "Nickname" || this.activeOptionIndex === 4;
            
            if (!isNicknameMode && !this.isFileUploadedSuccess) {
                alert("Lütfen devam etmek için bir dosya seçiniz veya 'Vazgeç' butonunu kullanınız.");
                return;
            }
            
            // 1. UI Kapat
            this.resetUI();

            // 2. Fiyatları Güncelle
            setTimeout(() => {
                if (typeof updateTotalPrice === 'function') updateTotalPrice();
                
                // Tekil Kutu Güncelle
                let priceKey = "";
                if (typeKey === "Ön Logo") priceKey = "ön";
                else if (typeKey === "Arka Logo") priceKey = "arka";
                else if (typeKey === "Bel Logo") priceKey = "bel";
                else if (typeKey === "Yastık Logo") priceKey = "üstyastık";
                else if (typeKey === "Nickname") priceKey = "nick";

                if (window.guncelleFiyat && priceKey) {
                    window.guncelleFiyat(priceKey);
                }
            }, 50);
        };
        
        confirmDiv.appendChild(btnCancel);
        confirmDiv.appendChild(btnConfirm);
        parentContainer.appendChild(confirmDiv);
    }
    
    // 7. handleDrop & handleFileSelect
    handleDrop(e) { e.preventDefault(); e.stopPropagation(); document.getElementById('uploadFileContainer').classList.remove('highlight'); this.processUploadedFile(e.dataTransfer.files[0]); }
    handleFileSelect(e) { this.processUploadedFile(e.target.files[0]); e.target.value = ''; }
    
    // 8. processUploadedFile
    // HawkUIController.js -> processUploadedFile GÜNCELLEMESİ

    // HawkUIController.js -> processUploadedFile

    // HawkUIController.js -> processUploadedFile (DATA OPTİMİZASYONU)

    async processUploadedFile(file) {
        const dropArea = document.getElementById('uploadFileContainer');
        const filenameSpan = dropArea ? dropArea.querySelector('.filename') : null;
        
        // Helper: UI Resetleme (Hata veya Bitiş durumunda)
        const resetUIState = (msg = "Dosya Seç") => {
            if(dropArea) {
                dropArea.style.pointerEvents = 'all';
                dropArea.style.opacity = '1';
                dropArea.style.border = '1px solid #ccc'; // Varsayılan border
                if(filenameSpan) filenameSpan.innerText = msg;
                dropArea.style.color = ""; // Rengi sıfırla
            }
            const smallLoader = document.getElementById('loadingbar');
            if (smallLoader) smallLoader.style.display = 'none';
        };

        // 1. Validasyon (Tip ve Boyut kontrolü burada yapılabilir ama boyut için resmi okumak lazım)
        if (!file || !file.type.startsWith('image/')) { 
            alert('Lütfen geçerli bir resim dosyası (.png, .jpg) yükleyin.'); 
            resetUIState("Hata! Tekrar Deneyin");
            return; 
        }

        // UI: Yükleniyor Modu
        const smallLoader = document.getElementById('loadingbar');
        if (smallLoader) smallLoader.style.display = 'flex'; 

        if(dropArea) { 
            dropArea.style.pointerEvents = 'none'; 
            dropArea.style.opacity = '0.5'; 
            if(filenameSpan) filenameSpan.innerText = "İşleniyor..."; 
        }

        try {
            const category = (this.globals.cinsbutton && this.globals.cinsbutton[0]) ? this.globals.cinsbutton[0] : "future";
            
            // processImage fonksiyonu boyut kontrolü yapıp null dönebilir
            const resizedUrl = await window.hawkUtils.processImage(file, this.activeOptionIndex, category);

            if (resizedUrl) {
                // BAŞARILI
                this.isFileUploadedSuccess = true;

                let typeLabel = "";
                let targetBoxId = "";

                const updateOrder = window.updateOrderJson || (window.checkoutManager ? window.checkoutManager.updateOrderData.bind(window.checkoutManager) : null);
                const FLAG_TEXT = "base64";

                if (this.activeOptionIndex === 1) { 
                    typeLabel = "Ön Logo"; this.globals.resultonlogo = [resizedUrl]; this.globals.onlogoyuklendi = true; targetBoxId = "onfiyati"; 
                    if(updateOrder) updateOrder(FLAG_TEXT, "Features.Patterns.Front");
                } 
                else if (this.activeOptionIndex === 2) { 
                    typeLabel = "Arka Logo"; this.globals.resultarkalogo = [resizedUrl]; this.globals.arkalogoyuklendi = true; targetBoxId = "arkafiyati"; 
                    if(updateOrder) updateOrder(FLAG_TEXT, "Features.Patterns.Back");
                }
                else if (this.activeOptionIndex === 3) { 
                    typeLabel = "Bel Logo"; this.globals.resultbellogo = [resizedUrl]; this.globals.bellogoyuklendi = true; targetBoxId = "belfiyati"; 
                    if(updateOrder) updateOrder(FLAG_TEXT, "Features.Patterns.Waist");
                }
                else if (this.activeOptionIndex === 5) { 
                    typeLabel = "Yastık Logo"; this.globals.resultyastiklogo = [resizedUrl]; this.globals.yastiklogoyuklendi = true; this.globals.nicknameyuklendi = false; targetBoxId = "isimfiyati"; 
                    if(updateOrder) updateOrder("data:image/png;base64,iVBORw0KGgoAAAA", "Features.Nickname.Text");
                }
                
                this.applyToMaterial(typeLabel, resizedUrl);
                
                if (targetBoxId) {
                    const box = document.getElementById(targetBoxId);
                    if (box) {
                        const xBtn = box.querySelector('.remove-button');
                        if (xBtn) xBtn.style.display = 'flex'; 
                    }
                }
                
                // UI: Başarılı
                if(dropArea) { 
                    dropArea.style.pointerEvents = 'all'; 
                    dropArea.style.opacity = '1'; 
                    dropArea.style.border = '2px solid #4CAF50'; 
                    if(filenameSpan) filenameSpan.innerText = "Dosya Hazır (Onaylayın)"; 
                    dropArea.style.color = "#4CAF50"; 
                }
            } else {
                // BAŞARISIZ (Boyut hatası veya işleme hatası)
                // processImage içinde alert verilmiş olabilir, biz UI'ı düzeltelim.
                resetUIState("Dosya Seç");
            }
        } catch (error) {
            console.error(error);
            resetUIState("Hata! Tekrar Deneyin");
        } finally {
            if (smallLoader) smallLoader.style.display = 'none';
        }
    }
    
    // 9. triggerNicknameUpdate
    // HawkUIController.js -> triggerNicknameUpdate GÜNCELLEMESİ

    // HawkUIController.js -> triggerNicknameUpdate

    triggerNicknameUpdate(text, color) {
        this.activeOptionIndex = 4;
        this.globals.nicknameyuklendi = true;
        this.globals.yastiklogoyuklendi = false;
        this.globals.logorenk = [color];
        
        // --- VERİ GÜNCELLEME ---
        const updateOrder = window.updateOrderJson || (window.checkoutManager ? window.checkoutManager.updateOrderData.bind(window.checkoutManager) : null);
        
        if(updateOrder) {
            updateOrder(text, "Features.Nickname.Text");   // Metni kaydet
            updateOrder(color, "Features.Nickname.Color"); // Rengi kaydet
        }
        // -----------------------
        
        let rawCat = (this.globals.cinsbutton && this.globals.cinsbutton[0]) ? this.globals.cinsbutton[0] : "future";
        if(window.hawkUtils) window.hawkUtils.drawTextToCanvas(text, color, rawCat.toLowerCase());

        if (text.trim().length > 0) {
            const box = document.getElementById("isimfiyati");
            if (box) {
                const xBtn = box.querySelector('.remove-button');
                if (xBtn) xBtn.style.display = 'flex';
            }
        }
    }
    
    // 10. applyToMaterial
    // HawkUIController.js -> applyToMaterial GÜNCELLEMESİ

   // HawkUIController.js -> applyToMaterial (FUTURE & PRO CLEAN SWAP)

  // HawkUIController.js -> applyToMaterial (FAME DESTEĞİ EKLENDİ)

  applyToMaterial(type, textureUrl) {
    if (!window.hawkMaterials || !window.hawk3D) return;
    

    let rawCat = this.globals.cinsbutton[0];
    const category = rawCat.charAt(0).toUpperCase() + rawCat.slice(1);
    const productTitle = (this.globals.tasarimismiKontrol && this.globals.tasarimismiKontrol[0]) ? this.globals.tasarimismiKontrol[0] : "";

    const mats = window.hawk3D.getModelMaterials();
    const map = window.hawkMaterials.getMaterialMap(category, mats, productTitle);
    
    let targetMat = null;

    // 1. HEDEF MATERYALİ BUL
    if (category === "Aksesuar") {
        if (type.includes("Bel")) targetMat = map["Bel Logo"];
        else if (type.includes("Yastık") || type.includes("Nickname")) targetMat = map["Yastık Logo"];
    } else {
        // Haritadan direkt bak (Dostane isim varsa: "Bel Logo")
        targetMat = map[type];

        // Eğer haritada dostane isim yoksa, teknik isimlerle Fallback yap:
        if (!targetMat) {
            // FUTURE
            if (category.includes("Future")) {
                if (type === "Bel Logo") targetMat = map["FUTURE bellogo"];
                if (type === "Ön Logo") targetMat = map["FUTURE ustlogo"];
                if (type === "Arka Logo") targetMat = map["FUTURE arkalogo"];
                if (type === "Yastık Logo") targetMat = map["FUTURE yastiklogo"];
            }
            // PRO
            else if (category.includes("Pro")) {
                if (type === "Bel Logo") targetMat = map["PRO BEL LOGO"];
                if (type === "Ön Logo") targetMat = map["PRO ON-LOGO"];
                if (type === "Arka Logo") targetMat = map["PRO ARKA-LOGO"];
                if (type === "Yastık Logo") targetMat = map["PRO BAS YASTIK LOGO"];
            }
            // FAB
            else if (category.includes("Fab")) {
                if (type === "Bel Logo") targetMat = map["FAB bel-logo"];
                if (type === "Ön Logo") targetMat = map["FAB ön-logo"];
                if (type === "Arka Logo") targetMat = map["FAB arka"];
                if (type === "Yastık Logo") targetMat = map["FAB fab-koltuk-logo"];
            }
            // --- EKLENEN KISIM: FAME ---
            else if (category.includes("Fame")) {
                if (type === "Bel Logo") targetMat = map["FAME bel-logo"];
                if (type === "Ön Logo") targetMat = map["FAME on-logo"];
                if (type === "Arka Logo") targetMat = map["FAME famegold"] || map["FAME arka-logo"];
                if (type === "Yastık Logo" || type === "Nickname") targetMat = map["FAME nickname"];
            }
        }
    }

    if (targetMat) {
        
        // 2. LOGOYU UYGULA
        window.hawkMaterials.applyTexture(targetMat, textureUrl);
        
        // 3. BEL LOGOSU İSE ARKA PLANLARI TEMİZLE (FUTURE & PRO İÇİN)
        if (type === "Bel Logo" || type.includes("Bel")) {
            
            // FUTURE
            if (category.includes("Future") && window.belCleanLink) {
                const cushionMat = map["FUTURE alt-yastik"];
                if (cushionMat) {
                    window.hawkMaterials.applyTexture(cushionMat, window.belCleanLink);
                }
            }

            // PRO
            else if (category.includes("Pro")) {
                if (window.proCleanLink && map["PRO YASTIK"]) {
                    window.hawkMaterials.applyTexture(map["PRO YASTIK"], window.proCleanLink);
                }
                if (window.probelcacheLink && map["PRO BEL IMZA"]) {
                    window.hawkMaterials.applyTexture(map["PRO BEL IMZA"], window.probelcacheLink);
                }
            }
            // FAME ve FAB için özel bir arka plan temizliği gerekmiyor (Logoları baked değil, ayrı katman).
        }

    } else {
        console.error(`   ❌ HATA: Hedef materyal BULUNAMADI! Tip: ${type}, Kategori: ${category}`);
        // Debug için map'i yazdıralım
        // console.log("   - Mevcut Map:", map);
    }
}
    
    // 11. triggerMaterialPopup
    triggerMaterialPopup(materialName, category) {
        const popup = document.getElementById("confirmationPopup");
        if (!popup) return;
        const popupText = popup.querySelector(".popup-content p");
        const confirmYes = document.getElementById("confirmYes");
        const confirmNo = document.getElementById("confirmNo");
        const popupContent = popup.querySelector(".popup-content");
        const oldBtns = popupContent.querySelectorAll("#addLogo, #addNickname");
        oldBtns.forEach(b => b.remove());
        confirmYes.style.display = "inline-block";
        const readableNames = { "yastik-logo.001": "Yastık Logosunu", "arkalogo.001": "Arka Logoyu", "bel-logo": "Bel Logosunu", "ustlogo.001": "Ön Logoyu", "ust-logo": "Yastık Logosunu", "logo-arkaa": "Arka Logoyu", "on-logo": "Ön Logoyu", "nickname": "Yastık Logosunu", "arka-logo": "Arka Logoyu", "onlogo": "Ön Logoyu", "yastiklogo.004": "Yastık Logosunu", "arkalogo": "Arka Logoyu" };
        const name = readableNames[materialName] || "bu alanı";
        const isPillow = ["yastik-logo.001", "ust-logo", "nickname", "yastiklogo.004"].includes(materialName);
        if (isPillow) {
            popupText.innerHTML = "Baş yastığına bir logo eklemek veya isim yazdırmak ister misiniz?";
            confirmYes.style.display = "none"; 
            const logoBtn = document.createElement("button"); logoBtn.id = "addLogo"; logoBtn.innerHTML = "Logo Ekle"; logoBtn.className = "comfirmation"; logoBtn.style.marginRight = "10px"; logoBtn.onclick = () => { this.updateActiveOption(5); popup.style.display = "none"; };
            const nickBtn = document.createElement("button"); nickBtn.id = "addNickname"; nickBtn.innerHTML = "İsim Yaz"; nickBtn.className = "comfirmation"; nickBtn.onclick = () => { this.updateActiveOption(4); popup.style.display = "none"; };
            popupContent.appendChild(logoBtn); popupContent.appendChild(nickBtn);
        } else {
            popupText.innerHTML = `${name} değiştirmek istediğinize emin misiniz?`;
            confirmYes.onclick = () => {
                let targetIndex = 0;
                if (name.includes("Ön")) targetIndex = 1; else if (name.includes("Arka")) targetIndex = 2; else if (name.includes("Bel")) targetIndex = 3;
                if (targetIndex > 0) this.updateActiveOption(targetIndex);
                popup.style.display = "none";
            };
        }
        popup.style.display = "flex";
        confirmNo.onclick = () => { popup.style.display = "none"; };
    }
    
   
    
    // 13. submitOrderTracking
    async submitOrderTracking() {
        const orderInput = document.getElementById('hawkOrderInput');
        const resultContainer = document.getElementById('hawkOrderResult');
        if (!orderInput || !resultContainer) return;
        const orderNo = orderInput.value.trim();
        if (!orderNo) { alert("Lütfen geçerli bir sipariş numarası girin."); return; }
        resultContainer.innerHTML = '<div style="text-align:center; color:#C41414; font-weight:bold;">⏳ Sorgulanıyor...</div>';
        resultContainer.style.display = 'block';
        try {
            const proxyUrl = window.HawkConfig?.API?.PROXY_URL || 'https://api.hawkgaming.com.tr/api/proxy';
            const response = await fetch(proxyUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ endpoint: '/order/detail', body: { OrderNo: orderNo } }) });
            const data = await response.json();
            const item = data.items?.[0];
            if (!item) throw new Error("Sipariş bulunamadı.");
            const createdDate = new Date(item.CreatedDate);
            const teslimDate = new Date(createdDate);
            teslimDate.setDate(teslimDate.getDate() + 28);
            resultContainer.innerHTML = `<div style="background:#f9f9f9; padding:15px; border-radius:10px; border:1px solid #eee; font-size:13px; line-height:1.6; color:#333;"><p><strong>Durum:</strong> <span style="color:#C41414;">${item._Statu}</span></p><p><strong>Alıcı:</strong> ${item.FirstName} ${item.LastName}</p><p><strong>Ürün:</strong> ${item._PatternName}</p><p><strong>Tahmini Teslim:</strong> ${teslimDate.toLocaleDateString('tr-TR')}</p><p style="font-size:11px; color:#666; margin-top:10px;">${item.DeliveryAddress}, ${item._DeliveryDistrict}/${item._DeliveryProvince}</p></div>`;
        } catch (err) { resultContainer.innerHTML = `<p style="color: #ffaaaa; text-align:center;">❌ Sipariş bulunamadı. Lütfen kodu kontrol edin.</p>`; }
    }
    
    // 14. initDarkMode
    initDarkMode() {
        const modeBtn = document.getElementById('hawkModeBtn');
        if (!modeBtn) return;
        let isDarkMode = false;
        modeBtn.addEventListener('click', () => {
            isDarkMode = !isDarkMode;
            document.body.classList.toggle('dark-mode', isDarkMode);
            
            modeBtn.style.backgroundImage = isDarkMode ? 'url(/static/image/lightmode.png)' : 'url(/static/image/darkmode.png)';
            this.applyDarkModeStyles(isDarkMode);
        });
    }
    
    // 15. applyDarkModeStyles
    applyDarkModeStyles(isDark) {
        const bgColor = isDark ? '#333333' : 'white';
        const textColor = isDark ? '#fafafa' : '#000000';
        const invertFilter = isDark ? 'invert(1)' : 'invert(0)';
        ['hawkgamingchair', 'customize-hawkchair-container'].forEach(id => { const el = document.getElementById(id); if(el) el.style.backgroundColor = bgColor; });
        ['title-containerUrunlerp', 'nextGraphic', 'trbilesen', 'trkoltuk1', 'hawkHelper', 'modelviewerAR'].forEach(id => { const el = document.getElementById(id); if(el) el.style.filter = invertFilter; });
        document.querySelectorAll('.header-logo img, .mobile-logo').forEach(img => { img.style.filter = invertFilter; });
        const contBg = isDark ? '#f3f3f308' : '#f3f3f35e';
        ['procontainer', 'futurecontainer', 'fabcontainer', 'famecontainer', 'aksesuarcontainer'].forEach(id => { const el = document.getElementById(id); if(el) el.style.backgroundColor = contBg; });
        document.querySelectorAll('.hawkchair-title').forEach(t => t.style.color = textColor);
        document.querySelectorAll('.selection-button').forEach(btn => { btn.style.backgroundColor = isDark ? '#3e3e3e' : '#e2e2e2c2'; btn.style.color = isDark ? 'white' : 'black'; });
    }

    // 16. initMobileUI & toggleMobileZIndex
    initMobileUI() {
        this.mobilePageNumber = 1;
        const viewPriceBtn = document.querySelector('.view-price');
        const viewComponentBtn = document.querySelector('.view-component');
        const nextGraphicBtn = document.getElementById('nextGraphic');
        const backButton = document.querySelector('.back-button');
        
        const containers = {
            patterns: document.querySelector('.patterns-container'),
            otherOpts: document.querySelector('.other-customize-options'),
            title: document.querySelector('.customize-title'),
            createOrderMob: document.querySelector('.create-order-button-mobil'), 
            selectionCont: document.querySelector('.selection-container'), 
            priceCont: document.querySelector('.price-container'),
            hawkCont: document.querySelector('.hawkchair-container'),
            titleCont: document.querySelector('.title-container'),
            otherSelOpts: document.querySelector('.other-selection-options'), 
            custSelCont: document.querySelector('.customize-selection-container'),
            mobileLogo: document.querySelector('.mobile-logo'),
            modelViewer: document.getElementById('hawkgamingchair'),
            mobilzamazingo: document.querySelector('.mobilezamazingo')
        };
        containers.mobilzamazingo.style.display="flex"
        if (nextGraphicBtn) {
            nextGraphicBtn.addEventListener('click', () => {
                if(containers.otherSelOpts) containers.otherSelOpts.classList.remove('active');
                if(containers.titleCont) containers.titleCont.classList.remove('active');
                nextGraphicBtn.classList.remove('active');
                if(containers.custSelCont) containers.custSelCont.classList.add('active');
                if(containers.hawkCont) setTimeout(() => containers.hawkCont.classList.add('top'), 300);
                if(viewComponentBtn) { viewComponentBtn.classList.add('active'); viewComponentBtn.style.zIndex = "99"; }
                this.toggleMobileZIndex(true); 
                
            });
        }

        if (viewComponentBtn) {
            viewComponentBtn.addEventListener('click', () => {
                const isActive = viewComponentBtn.classList.contains('show');
                if (isActive) {
                    if(containers.selectionCont) {containers.selectionCont.classList.remove('active');containers.selectionCont.style.zIndex = "0";}
                    if(viewPriceBtn) viewPriceBtn.classList.remove('active');
                    viewComponentBtn.classList.remove('show');
                } else {
                    if(containers.selectionCont) { containers.selectionCont.classList.add('active'); containers.selectionCont.style.zIndex = "100"; }
                    if(viewPriceBtn) { viewPriceBtn.classList.add('active'); viewPriceBtn.style.zIndex = "100"; }
                    viewComponentBtn.classList.add('show');
                }
            });
        }

        if (viewPriceBtn) {
            viewPriceBtn.addEventListener('click', (e) => {
                if (window.innerWidth <= 1000) {
                    e.preventDefault();
                    this.mobilePageNumber = 2;
                    if(containers.patterns) containers.patterns.classList.add('hidden');
                    if(containers.otherOpts) containers.otherOpts.classList.add('hidden');
                    if(containers.title) containers.title.classList.add('hidden');
                    if(containers.selectionCont) containers.selectionCont.classList.remove('active');
                    if(containers.mobileLogo) containers.mobileLogo.classList.add('hidden');
                    if(viewComponentBtn) viewComponentBtn.classList.remove('show', 'active');
                    if(viewPriceBtn) viewPriceBtn.classList.remove('active'); 
                    if(containers.otherSelOpts) { containers.otherSelOpts.style.zIndex = "200"; }
                    if(containers.priceCont) { containers.priceCont.classList.add('active'); containers.priceCont.style.zIndex = "201"; }
                    if(containers.createOrderMob) { containers.createOrderMob.classList.remove('hidden'); containers.createOrderMob.style.display = "block"; containers.createOrderMob.style.zIndex = "202"; }
                    if(containers.hawkCont) setTimeout(() => containers.hawkCont.classList.add('top2'), 300);
                }
            });
        }

        if (backButton) {
            backButton.addEventListener('click', () => {
                if (this.mobilePageNumber === 1) {
                    if(viewComponentBtn) viewComponentBtn.classList.remove('active', 'show');
                    if(containers.hawkCont) containers.hawkCont.classList.remove('top');
                    if(containers.selectionCont) {containers.selectionCont.classList.remove('active'); containers.selectionCont.style.zIndex = "0";} 

                    if(viewPriceBtn) viewPriceBtn.classList.remove('active');
                    viewComponentBtn.style.zIndex = "-1";
                    setTimeout(() => {
                        if(containers.titleCont) containers.titleCont.classList.add('active');
                        if(containers.otherSelOpts) containers.otherSelOpts.classList.add('active');
                        if(nextGraphicBtn) nextGraphicBtn.classList.add('active');
                        if(containers.custSelCont) containers.custSelCont.classList.remove('active');
                    }, 300);
                    this.toggleMobileZIndex(false); 
                  
                } else {
                    this.mobilePageNumber = 1;
                    if(containers.otherSelOpts) { containers.otherSelOpts.style.zIndex = ""; }
                    if(containers.priceCont) containers.priceCont.classList.remove('active');
                    if(containers.createOrderMob) containers.createOrderMob.classList.add('hidden');
                    if(containers.hawkCont) containers.hawkCont.classList.remove('top2');
                    if(viewComponentBtn) viewComponentBtn.classList.add('active');
                    containers.selectionCont.style.zIndex = "0";
                    setTimeout(() => {
                        if(containers.mobileLogo) containers.mobileLogo.classList.remove('hidden');
                        if(containers.patterns) containers.patterns.classList.remove('hidden');
                        if(containers.otherOpts) containers.otherOpts.classList.remove('hidden');
                        if(containers.title) containers.title.classList.remove('hidden');
                    }, 300);
                }
            });
        }
    }

    toggleMobileZIndex(isEditing) {
        const modelViewer = document.getElementById('hawkgamingchair');
        const otherElement = document.querySelector(".other-selection-options");
        const titleContainer = document.getElementById("title-containerUrunler");
        if (!modelViewer) return;
        if (isEditing) {
            modelViewer.classList.remove('normal'); modelViewer.classList.add('fullscreen'); modelViewer.style.zIndex = "0"; 
            if(otherElement) otherElement.style.zIndex = "0";
            if(titleContainer) titleContainer.style.zIndex = "0";
        } else {
            modelViewer.classList.remove('fullscreen'); modelViewer.classList.add('normal'); modelViewer.style.zIndex = ""; 
            if(otherElement) otherElement.style.zIndex = "unset";
            if(titleContainer) titleContainer.style.zIndex = "35";
        }
    }

    bindButton(id, index) {
        const btn = document.getElementById(id);
        if(btn) {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.updateActiveOption(index);
            });
        }
    }
}
window.checksiparis = () => {
    if (window.hawkUI) window.hawkUI.checkOrderStatus();
};
window.hawkUI = new HawkUIController();